/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import "@angular/compiler";
import { AuthService } from "./services/auth.service";
import { AuthGuard } from "./services/auth.guard";
import { UtilService } from "./services/util.service";
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

import { DashboardLayoutComponent } from "./layouts/dashboard-layout/dashboard-layout.component";
import { AuthenticationLayoutComponent } from "./layouts/authentication-layout/authentication-layout.component";
import { CookieModule } from "ngx-cookie";
import { DataService } from "./services/data.service";

import { CommonModule } from "@angular/common";
import { ToastrModule } from "ngx-toastr";
import {
  SocialLoginModule,
  SocialAuthServiceConfig,
} from "angularx-social-login";

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSpinnerService,
} from "@nebular/theme";
import '@lottiefiles/lottie-player';
import { RouterModule } from "@angular/router";
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "angularx-social-login";

export function playerFactory() {
  return player;
}
@NgModule({
  declarations: [
    AppComponent,
    DashboardLayoutComponent,
    AuthenticationLayoutComponent,
  ],
  imports: [
    SocialLoginModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(AppRoutingModule),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: "AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY",
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    CookieModule.forRoot(),
    CommonModule,
    ToastrModule.forRoot(), // ToastrModule added
    LottieModule.forRoot({ player: playerFactory })
  ],
  providers: [
    NbSpinnerService,
    AuthService,
    AuthGuard,
    UtilService,
    DataService,
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider("clientId"),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider("1332845487160254"),
          },
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
